import { faArrowUpRightFromSquare } from '@fortawesome/pro-regular-svg-icons';
import * as React from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate, useParams } from 'react-router-dom';

import EmptyStage from '../../../../core/components/EmptyStage.tsx';
import { withIcon } from '../../../../core/components/Icon.tsx';
import { url } from '../../../../core/utils/link.ts';
import { ASSISTANT_PATH, ASSISTANT_RECORD_PATH, OUTLOOK_ADD_IN_URL } from '../../constants.ts';
import AgentActivity from '../activity/AgentActivity.tsx';

const ExternalLinkIcon = withIcon(faArrowUpRightFromSquare);

interface AssistantActivityTabProps {
    agent: { id: string };
}

/** The emails the assistant handled. Test runs aren't listed here. */
const AssistantActivityTab = ({ agent }: AssistantActivityTabProps) => {
    const { t } = useTranslation('assistants', { keyPrefix: 'detail.activity' });
    const navigate = useNavigate();
    const { recordId = null } = useParams();

    const openRecord = (id: string | null) =>
        navigate(
            id
                ? url(ASSISTANT_RECORD_PATH, { channelId: agent.id, recordId: id }, { keepSearch: true })
                : url(ASSISTANT_PATH, { channelId: agent.id, tab: 'activity' }, { keepSearch: true })
        );

    return (
        <AgentActivity
            agentId={agent.id}
            storageKey={`assistant-${agent.id}-activity`}
            filtersInline
            selectedRecordId={recordId}
            onSelectedRecordChange={openRecord}
            emptyState={
                <EmptyStage
                    size={88}
                    title={t('emptyTitle')}
                    description={t('emptyDescription')}
                    action={
                        <a
                            href={OUTLOOK_ADD_IN_URL}
                            target="_blank"
                            rel="noopener noreferrer"
                            className="inline-flex items-center gap-1.5 rounded text-sm font-medium text-content-brand-default underline-offset-2 hover:text-content-brand-hover hover:underline active:text-content-brand-active focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-line-brand-strong"
                        >
                            {t('setUpOutlook')}
                            <ExternalLinkIcon />
                        </a>
                    }
                />
            }
        />
    );
};

export default AssistantActivityTab;
